<nz-spin [nzSpinning]="loading$ | async">
  <form nz-form class="form" nzLayout="horizontal">
    <div class="drawer-form-wrapper">
      <div class="behaviour-card-sec" *ngIf="caseDetail && caseDetail.student">
        <div class="header-with-cta mb-24">
          <h3 class="title s-18">
            {{ caseDetail.student.firstName }} {{ caseDetail.student.lastName }}
          </h3>
        </div>
        <div class="card-content-wrapper">
          <div class="content">
            <h4 class="title">Date Of Birth</h4>
            <p class="desc">
              <svg-icon
                src="/assets/icon/icon-calendar.svg"
                class="icon s-16"
                aria-label="Calendar"></svg-icon>
              {{ caseDetail.student.dateOfBirth | date: 'MM/dd/yyyy' }}
            </p>
          </div>
          <div class="content">
            <h4 class="title">Supervisor</h4>
            <p class="desc">
              <svg-icon
                src="/assets/icon/icon-supervisor.svg"
                class="icon s-16"
                aria-label="Supervisor"></svg-icon>
              {{ caseDetail.supervisorName }}
            </p>
          </div>
          <div class="content">
            <h4 class="title">Gender</h4>
            <p class="desc">
              <svg-icon
                src="/assets/icon/icon-male.svg"
                class="icon s-18"
                aria-label="Male"></svg-icon>
              {{ caseDetail.student.gender }}
            </p>
          </div>
        </div>
      </div>
      <!-- options -->
      <app-report-form
        *ngIf="stepNumber === 1"
        [formData]="reportData"
        (formValueChange)="formValueChange($event)"></app-report-form>
      <app-report-graph
        *ngIf="stepNumber !== 1"
        [graphData]="reportForm.formValue"
        (formValueChange)="handleGraph($event)"></app-report-graph>
      <div class="display-flex justify-content-between drawer-footer">
        <button
          *ngIf="stepNumber !== 1"
          nz-button
          type="button"
          nzType="default"
          (click)="onPrev()"
          [disabled]="stepNumber === 1">
          Previous
        </button>
        <button
          *ngIf="stepNumber === 1"
          nz-button
          type="button"
          nzType="default"
          (click)="onCancel()">
          Cancel
        </button>
        <div class="footer-right">
          <button
            nz-button
            type="button"
            nzType="primary"
            (click)="onNext()"
            *ngIf="stepNumber === 1"
            [disabled]="
              !reportForm.isFormValid ||
              reportForm.formValue.graphList?.length === 0
            ">
            Next
          </button>
          <!-- save button -->
          <button
            nz-button
            type="button"
            nzType="primary"
            *ngIf="stepNumber !== 1"
            (click)="submitReport()">
            Save
          </button>
        </div>
      </div>
    </div>
  </form>
</nz-spin>
